// import apiMeta from "../../api/apiMeta";
import { createAsyncThunk } from "@reduxjs/toolkit";
import apiPrakasak from "../../api/apiPrakasak";

export const createPrakasak = async (body) => {
  return await apiPrakasak.post("saveStudentsRecords", body);
};

export const getPrakasak = async (params) => {
  try {
    const response = await apiPrakasak.get(
      `getStudentsRecords/${params?.year}`
    );
    return {
      data: response.data,
      status: response.status,
    };
  } catch (err) {
    console.err(">>> Axios Error:", err);
    throw { status: err.code, message: err.message };
  }
};
export const getPrakasakDataHistory = async (params) => {
  try {
    const response = await apiPrakasak.get(`getUploadTrans`);
    return {
      data: response.data,
      status: response.status,
    };
  } catch (err) {
    console.err(">>> Axios Error:", err);
    throw { status: err.code, message: err.message };
  }
};

export const deletePrakasak = async (body) => {
  console.log("body in api", body);
  return await apiPrakasak.delete("deleteStudentsRecord", { data: body });
};
export const createPrakasakData = async (body) => {
  return await apiPrakasak.post("createRemoteInstrRecords", body);
};
export const getPrakasakData = async (data) => {
  return await apiPrakasak.get(`getRemoteInstrRecords/${data.selectedOption}`);
};
//!-----For the remote instructions----------------
export const deletePrakasakData = async (body) => {
  console.log("body in api", body);
  return await apiPrakasak.delete("deleteRemoteInstrRecords", { data: body });
};

export const updatePrakashakData = async (body) => {
  return await apiPrakasak.put(`updateStudentRecord`, body);
};

//-----------------Remote instruction Delete and Edit-----------------------
export const deleteRemoteInstruction = async (data) => {
  // console.log("body in api", type, _id);
  // const { type, _id } = params;

  try {
    const response = await apiPrakasak.delete(
      `deleteRemoteInstrRecord/${data.type}/${data._id}`
    );
    console.log(
      "response delete trigger group --->",
      response.data,
      response.status
    );
    return {
      data: response.data,
      status: response.status,
    };
  } catch (err) {
    console.err(">>> Axios Error:", err);
    throw { status: err.code, message: err.message };
  }
};

export const updateRemoteInstruction = async (body) => {
  try {
    const response = await apiPrakasak.put(`updateRemoteInstrRecord`, body);
    console.log(
      "response update trigger group --->",
      response.data,
      response.status
    );
    return {
      data: response.data,
      status: response.status,
    };
  } catch (err) {
    console.err(">>> Axios Error:", err);
    throw { status: err.code, message: err.message };
  }
};

export const getRemoteInstruUploadStatus = async (params) => {
  try {
    const response = await apiPrakasak.get(
      `/getRemoteInstruUploadStatus/${params?.year}/${params?.month}/${params?.remoteInstruType}`
    );
    return {
      data: response.data,
      status: response.status,
    };
  } catch (err) {
    console.err(">>> Axios Error:", err);
    throw { status: err.code, message: err.message };
  }
};

export const flagRemoteInstruUploadComplete = async (body) => {
  try {
    const response = await apiPrakasak.post(
      `flagRemoteInstruUploadComplete`,
      body
    );
    console.log(
      "response update trigger group --->",
      response.data,
      response.status
    );
    return {
      data: response.data,
      status: response.status,
    };
  } catch (err) {
    console.err(">>> Axios Error:", err);
    throw { status: err.code, message: err.message };
  }
};

//-------------------Remote instruction edit and delete -------------------
